export default __webpack_public_path__ + "static/media/caret-up.0eb0c7b6.svg";